import React from 'react';
import { Button } from '@material-ui/core';

const RMSButton = ({
  label,
  prefixIcon,
  suffixIcon,
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  onClick,
  disabled = false,
  className,
  ...rest
}) => {
  return (
    <Button
      className={className}
      variant={variant}
      color={color}
      size={size}
      startIcon={prefixIcon}
      onClick={onClick}
      disabled={disabled}
      endIcon={suffixIcon}
      {...rest}>
      {label}
    </Button>
  );
};

export default RMSButton;

/**
 * RMSButton Component
 *
 * Example:
 * <RMSButton
 *   label="Save"
 *   prefixIcon={<SaveIcon />}
 *   variant="contained"
 *   color="primary"
 *   size="medium"
 *   onClick={handleSave}
 *   suffixIcon={<SaveIcon />}
 * />
 *
 * Available Props:
 * label       : string
 * prefixIcon  : ReactNode
 * suffixIcon  : ReactNode
 * variant     : 'contained' | 'outlined' | 'text'
 * color       : 'default' | 'inherit' | 'primary' | 'secondary'
 * size        : 'small' | 'medium' | 'large'
 * disabled    : boolean
 * onClick     : function
 *
 * Note:
 * 'success', 'error', 'warning', and 'info' are not supported in Material-UI v4.
 * Use custom CSS classes if you need additional colors.
 *
 * Supports all Material-UI <Button /> props via ...rest.
 */